function swymCallbackFn(swat){

  /*custom buttons in swym page*/
  if (window.location.pathname === '/pages/swym-wishlist') {
    const observer = new MutationObserver((mutations) => {
      const el = document.querySelector('.swym-htc-tabs');
      if(el){
        const back_link = document.createElement('a');
        back_link.href = window.theme?.routes?.customer_main_page;
        back_link.className = 'back-to-the-account';
        back_link.innerHTML = '&larrhk; ' + window.theme?.strings?.returnToAccount;
        el.insertBefore(back_link, el.firstChild);

        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /*swym reload wishlist buttons after dynamic loaded content (like collection filtered results)*/
  document.addEventListener("swym:collections-loaded", function(){
    swat.initializeActionButtons(".collection-container");
  })

  swat.evtLayer.addEventListener(SwymTracker.JSEvents.addedToWishlist, function(e){
return false;
    var product_id = e.detail.d.empi;
    let event_payload = {};//JSON.parse(this.closest('.product').querySelector('[data-item-data-layer]').innerHTML);
    if(document.querySelector(`.product--${product_id} [data-item-data-layer]`)){
      event_payload = JSON.parse(document.querySelector(`.product--${product_id} [data-item-data-layer]`).innerHTML);
    }
    else {
      event_payload = JSON.parse(document.querySelector(`.product-card--${product_id} [data-item-data-layer]`).innerHTML);
    }
    Shopify.analytics.publish('add_to_wishlist_custom', {payload: event_payload });
  });
  
  swat.evtLayer.addEventListener('sw:addedtocart', function(e){
    if(!e?.detail?.d?.productData?.id) return false;
    setTimeout(() => {
      let event_payload = document.querySelector(`.cart-drawer .product-cart-item[data-product-variant='${e.detail.d.productData.id}'] [data-item-data-layer]`);
      if(!event_payload) return false;
      event_payload = JSON.parse(event_payload.innerHTML);
      event_payload.quantity = e.detail.d.quantity ?? 1;
      Shopify.analytics.publish('product_added_to_cart_custom', {payload: event_payload});
    }, 1000);
  });

  //override the swym cart api to support custom slider cart 
  var replayAddToCartOriginalFn = swat.replayAddToCart;
  swat.replayAddToCart = function() {
    //save the successCallback
    var successCallbackFn = arguments[2];
    arguments[2] = function(data) {
      if (successCallbackFn && updateThirdPartyCartFn) {
        successCallbackFn(data);
        updateThirdPartyCartFn(data);
      };
    }
    //call the orginal fn
    replayAddToCartOriginalFn.apply(this, arguments);
  };
  //runs on success callback.
  function updateThirdPartyCartFn(productData) {
    // Successfully added to cart API, Now call cart drawer update here.
    var cartDrawer = document.querySelector('cart-drawer');
    var items = JSON.parse(productData);
    items = items?.items;
    if(!items) return false;

    var fetch_sections = cartDrawer.getSectionsToRender().map((section) => section.section) 
    fetch('/?sections=' + fetch_sections.join(','))
      .then((response) => response.json())
      .then((response) => {
        var item = items[0];
        item['sections'] = response;
        cartDrawer.renderContents(item);
      });

    
  }
  //end override the swym cart api
  
}

function customSwymRenderRecentItems(container,items) {
  if(!container) return;
  let container_title = container.querySelector('h3'),
    container_button = container.querySelector('a span'),
    container_products = container.querySelector('.customer-list-products'),
    container_empty = container.querySelector('.container-empty');

  if(items.length){
    if(items.length>3){
      container_products.classList.add('show-more');
    }
    container_title.innerHTML = window.theme.customer_wishlist_strings.title;
    container_button.innerHTML = window.theme.customer_wishlist_strings.button;
    container_empty?.remove();//classList?.add('hidden');
  } else {
    container_title.innerHTML = window.theme.customer_wishlist_strings.title_empty;
    container_button.innerHTML = window.theme.customer_wishlist_strings.button_empty;
    container_empty?.classList?.remove('hidden');    
  }

  items.forEach(item => {
    let product_featured_media = item.iu;
    const el = document.createElement('a');
    el.setAttribute('href',item.du);
    el.innerHTML = `<img src="${product_featured_media}" alt="${item.dt}" />`;
    container_products?.appendChild(el);
  });
}

function customSwymFetchProducts(container) {
  _swat.fetch(function(products) {
    // Sort by added date (most recent first)
    const sorted = products.sort((a, b) => new Date(b.dt) - new Date(a.dt));

    // Show the top N recent products (e.g. top 5)
    const recent = sorted.slice(0, 5);
    
    console.log("Most recent wishlist items:", recent);

    // Render them however you want
    customSwymRenderRecentItems(container,recent);
  });
}


if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);

window.SwymCallbacks.push(function() {
  const container = document.querySelector('.customer-card-wishlish');
  if(!container) return;
  customSwymFetchProducts(container);
});